// extracted by mini-css-extract-plugin
export default {"BPMWrapper":"BPM_BPMWrapper__3nE2z","BPM":"BPM_BPM__fbSvi","BpmIcons":"BPM_BpmIcons__OEgWW"};